import { IconName } from '@optimus-web/icons';

const mapLegacyValues = (value: string) => {
    switch (value) {
        case 'add_box':
            return IconName.Add;
        case 'add_circle':
            return IconName.PlusSimple;
        case 'add_to_queue':
            return IconName.PlusSimple;
        case 'all_out':
            return IconName.CheckedIn;
        case 'arrow_downward':
            return IconName.ArrowDown;
        case 'arrow_forward':
            return IconName.ArrowRight;
        case 'arrow_upward':
            return IconName.ArrowUp;
        case 'attach_money':
            return IconName.PaymentReport;
        case 'trending_down':
            return IconName.Availability;
        case 'backspace':
            return IconName.Rebate;
        case 'backup':
            return IconName.ImportCustomers;
        case 'business':
            return IconName.Property;
        case 'call_missed_outgoing':
            return IconName.Refund;
        case 'cancel':
            return IconName.Disable;
        case 'card_giftcard':
            return IconName.Birthday;
        case 'card_travel':
            return IconName.Preauthorization;
        case 'check':
            return IconName.Done;
        case 'check_circle':
            return IconName.CheckCircle;
        case 'clear':
            return IconName.Broom;
        case 'close':
            return IconName.CrossClose;
        case 'credit_card':
            return IconName.PaymentCard;
        case 'device_hub':
            return IconName.DeviceCommand;
        case 'dialpad':
            return IconName.Terminal;
        case 'event_note':
            return IconName.ActionLog;
        case 'exit_to_app':
            return IconName.Exports;
        case 'file_download':
            return IconName.Download;
        case 'flash_on':
            return IconName.Jobs;
        case 'flight_land':
            return IconName.Arrivals;
        case 'flight_takeoff':
            return IconName.Departures;
        case 'folder_open':
            return IconName.FolderOpened;
        case 'history':
            return IconName.PastShifts;
        case 'insert_chart':
            return IconName.RateManagement;
        case 'keyboard_tab':
            return IconName.ExternalPayment;
        case 'language':
            return IconName.Cultures;
        case 'layers_clear':
            return IconName.Broom;
        case 'lens':
            return IconName.CheckedOut;
        case 'link':
            return IconName.CustomLink;
        case 'local_atm':
            return IconName.BillsInvoices;
        case 'monetization_on':
            return IconName.ExecuteMerchant;
        case 'money_off':
            return IconName.PaymentAttempts;
        case 'trending_up':
            return IconName.Occupancy;
        case 'pageview':
            return IconName.Summary;
        case 'panorama_fish_eye':
            return IconName.Blacklist;
        case 'pan_tool':
            return IconName.Assign;
        case 'payment':
            return IconName.PaymentCard;
        case 'person':
            return IconName.Profile;
        case 'photo_camera':
            return IconName.Camera;
        case 'power':
            return IconName.Connect;
        case 'public':
            return IconName.ChannelManager;
        case 'redo':
            return IconName.Stayovers;
        case 'router':
            return IconName.TerminalPayment;
        case 'shop':
            return IconName.Merchant;
        case 'shopping_cart':
            return IconName.Items;
        case 'slideshow':
            return IconName.Charge;
        case 'star':
            return IconName.VeryImportant;
        case 'star_border':
            return IconName.Stars;
        case 'store':
            return IconName.Marketplace;
        case 'touch_app':
            return IconName.Execute;
        case 'vertical_align_center':
            return IconName.Restriction;
        case 'visibility':
            return IconName.Show;
        case 'vpn_key':
            return IconName.SpaceStatus;
        case 'weekend':
            return IconName.ExtraBed;
        default:
            return value;
    }
};

export default mapLegacyValues;
